import store from "@/store";
import metamask from "@/lib/metamask/index";

async function login(){
    await metamask.wallet.connectWallet()
    const loginMsg = "Welcome to Decentral Store!\n" +
        "\n" +
        "This request will not trigger a blockchain transaction or cost any gas fees.\n" +
        "\n" +
        "Your authentication status will reset after 24 hours.\n" +
        "\n" +
        "Wallet address:\n" +
        `${store.state.loggedInAccount}\n` +
        "\n" +
        "Timestamp:\n" +
        `${new Date().getTime()}\n`

    const loginMsgSignature = await metamask.wallet.personalSign(loginMsg)

    if (loginMsgSignature){
        const authToken = {
            loginMsg,
            loginMsgSignature
        }
        localStorage.setItem('authToken', JSON.stringify(authToken))
    }
}

async function logout() {
    if (localStorage.getItem('authToken')){
        localStorage.removeItem('authToken')
    }
    window.location.reload()
}



export default {
    login,
    logout
}